module.exports = __webpack_public_path__ + "static/media/wizualizacja-48.586a40e7.png";